import { useState, useEffect } from 'react'
import './App.css'
import { AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers'
import {
    Login,
    Signup,
    SubmitShift,
    SelectStore,
    SelectMonth,
    Calendar,
    Home,
    CheckFinalizedMonths,
    CheckFinalizedCalendar,
    CheckShiftDay,
    RecurringShifts,
    ManagerSettings,
    CreateShiftStores,
    CreateShiftMonths,
    SubmittedEmployees,
    UserSettings,
    ForgotPassword,
    ResetPassword,
    MonthlyShiftHeader,
    EmailConfirmation,
    AdminUserManagements,
    AdminUserManagementEdit,
    AdminUserBulkUpload,
    AdminStoreManagements,
    AdminUserManagementList,
    AdminStoreBulkUpload,
    ResendConfirmation,
    AdminHLG,
    ViewOnlyHome,
    ShiftManagements,
    FeedbackManagements,
    Layout,
} from './Components'
import { PATHS } from './constants'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { EmploymentsContext } from './contexts/EmploymentsContext'
import { AxiosWithAuth } from './Utilities/authenticationService'
import chatScheduler from './Components/openai-stuff/partTimerScheduler'

function App() {
    const [userEmployments, setUserEmployments] = useState([])
    const [isManager, setIsManager] = useState(false)
    const [isManagerFor, setIsManagerFor] = useState({})
    const [canEditShift, setCanEditShift] = useState(false)
    const [canEditShiftFor, setCanEditShiftFor] = useState({})
    const [userInfo, setUserInfo] = useState({})
    const [isAdmin, setIsAdmin] = useState(false)

    const resetAppsStates = () => {
        setUserEmployments([])
        setIsManager(false)
        setIsManagerFor({})
        setCanEditShift(false)
        setCanEditShiftFor({})
        setUserInfo({})
        setIsAdmin(false)
    }

    const fetchAndSetEmployments = () => {
        AxiosWithAuth.get('/employments')
            .then(res => {
                setUserEmployments(res.data)
            })
            .catch(() => {
                setUserEmployments([])
            })
    }
    const fetchAndSetUserInfo = () => {
        AxiosWithAuth.get('/users/me')
            .then(user => {
                setUserInfo(user.data)
                setIsAdmin(user.data?.is_admin)
            })
            .catch(() => console.log('401 get /users/me'))
    }
    useEffect(() => {
        fetchAndSetEmployments()
        fetchAndSetUserInfo()
    }, [])

    useEffect(() => {
        if (userEmployments.length > 0) {
            setIsManager(userEmployments.some(employment => employment.is_manager))
            setCanEditShift(userEmployments.some(employment => employment.can_edit_shift))
            userEmployments.forEach(employment => {
                setIsManagerFor(prev => {
                    return {
                        ...prev,
                        [employment.id]: employment.is_manager
                    }
                })
                setCanEditShiftFor(prev => {
                    return {
                        ...prev,
                        [employment.id]: employment.can_edit_shift
                    }
                })
            })
        }
        if (localStorage.getItem('currentUser')) {
            setIsAdmin(JSON.parse(localStorage.getItem('currentUser')).is_admin)
        }
    }, [userEmployments, userInfo])

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <Router basename={process.env.PUBLIC_URL}>
                <EmploymentsContext.Provider
                    value={{
                        userEmployments,
                        setUserEmployments,
                        isManager,
                        isAdmin,
                        userInfo,
                        isManagerFor,
                        canEditShift,
                        canEditShiftFor,
                        fetchAndSetEmployments,
                        resetAppsStates
                    }}
                >
                    <Switch>
                        <Route exact path="/">
                            <Redirect to={PATHS.home} />
                        </Route>
                        {/*TODO: add home path public route with token */}
                        <Route
                            path={PATHS.login}
                            component={props => {
                                return (
                                    <Login
                                        {...props}
                                        fetchAndSetEmployments={fetchAndSetEmployments}
                                        fetchAndSetUserInfo={fetchAndSetUserInfo}
                                    />
                                )
                            }}
                        />
                        <Route path={PATHS.forgotPassword} component={ForgotPassword} />
                        <Route path={PATHS.resetPassword} component={ResetPassword} />
                        <Route path={PATHS.confirmation} component={EmailConfirmation} />
                        <Route path={PATHS.resendConfirmation} component={ResendConfirmation} />
                        <Route path="/">
                            <Layout>
                        
                                <Route path={PATHS.signup} component={Signup} />
                                <Route path={PATHS.home} component={Home} />
                                <Route path={PATHS.submitShift} component={SubmitShift} />{' '}
                                {/* reverse order for routing to work, will fix with nesting later */}
                                <Route path={PATHS.calendar} component={Calendar} />
                                <Route path={PATHS.months} component={SelectMonth} />
                                <Route path={PATHS.stores} component={SelectStore} />
                                <Route path={PATHS.check} component={CheckFinalizedMonths} />
                                <Route path={PATHS.checkCalendar} component={CheckFinalizedCalendar} />
                                <Route path={PATHS.checkDay} component={CheckShiftDay} />
                                <Route path={PATHS.checkMonthlyShift} component={MonthlyShiftHeader} />
                                <Route path={PATHS.createMonthlyShift} component={MonthlyShiftHeader} />
                                <Route path={PATHS.recurring} component={RecurringShifts} />
                                <Route path={PATHS.userSettings} component={UserSettings} />
                                <Route path={PATHS.managerSettings} component={ManagerSettings} />
                                <Route exact path={PATHS.submittedEmployees} component={SubmittedEmployees} />
                                <Route path={PATHS.createDay} component={CheckShiftDay} />
                                <Route path={PATHS.createCalendar} component={CheckFinalizedCalendar} />
                                <Route exact path={PATHS.managerStores} component={CreateShiftStores} />
                                <Route exact path={PATHS.managerMonths} component={CreateShiftMonths} />
                                <Route exact path={PATHS.adminUserManagements} component={AdminUserManagements} />
                                <Route path={PATHS.adminUserManagementEdit} component={AdminUserManagementEdit} />
                                <Route path={PATHS.adminUserBulkUpload} component={AdminUserBulkUpload} />
                                <Route path={PATHS.adminStoreBulkUpload} component={AdminStoreBulkUpload} />
                                <Route exact path={PATHS.adminStoreManagements} component={AdminStoreManagements} />
                                <Route exact path={PATHS.adminStoreUserList} component={AdminUserManagementList} />
                                <Route exact path={PATHS.adminHLG} component={AdminHLG} />
                                <Route path={'/chatScheduler'} component={chatScheduler} />
                                <Route path={PATHS.viewOnly.checkMonthlyShiftMobile} component={CheckFinalizedCalendar} />
                                <Route path={PATHS.viewOnly.checkMonthlyShift} component={MonthlyShiftHeader} />
                                <Route path={PATHS.shiftManagement} component={ShiftManagements} />
                                <Route path={PATHS.feedbackManagement} component={FeedbackManagements} />
                                <Route path={PATHS.viewOnly.home} component={ViewOnlyHome} />
                            </Layout>
                        </Route>
                    </Switch>
                </EmploymentsContext.Provider>
            </Router>
        </LocalizationProvider>
    )
}

export default App
